import { Navigate, createBrowserRouter } from "react-router-dom";
import {
  CustomerDetailsPage,
  CustomerListPage,
  DashboardV2Page,
  LoginPage,
  SettingsPage,
  NotFound,
  ForecastPage,
  ChurnPage,
  DashboardUsageDropPage,
  Integrations,
} from "./pages";
import { useAuth } from "./hooks";
import { Spinner } from "flowbite-react";
import { GoalsProvider } from "./hooks/useGoals";
import { ROUTES } from "./routes";

// Paths live in ./routes so leaf components can build a URL without importing every page.
// Re-exported here for the existing call sites.
export { ROUTES, customerDetailPath, integrationPath } from "./routes";

export const PrivateRoute = ({ children }) => {
  const { isLoggedIn, isCheckingAuth } = useAuth();

  if (isCheckingAuth) {
    return (
      <div className="flex h-full w-full items-center justify-center">
        <Spinner aria-label="Extra large spinner example" size="xl" />
      </div>
    );
  }

  if (!isLoggedIn) {
    return <Navigate to={ROUTES.login} replace />;
  }

  return children;
};

export const router = createBrowserRouter([
  {
    path: ROUTES.root,
    element: (
      <PrivateRoute>
        <GoalsProvider>
          <DashboardV2Page />
        </GoalsProvider>
      </PrivateRoute>
    ),
  },
  {
    path: ROUTES.login,
    element: <LoginPage />,
  },
  {
    path: ROUTES.dashboard,
    element: (
      <PrivateRoute>
        <GoalsProvider>
          <DashboardV2Page />
        </GoalsProvider>
      </PrivateRoute>
    ),
  },
  {
    path: ROUTES.dashboardUsageDrop,
    element: (
      <PrivateRoute>
        <DashboardUsageDropPage />
      </PrivateRoute>
    ),
  },
  {
    path: ROUTES.customers,
    element: (
      <PrivateRoute>
        <CustomerListPage />
      </PrivateRoute>
    ),
  },
  {
    path: ROUTES.customerDetails,
    element: (
      <PrivateRoute>
        <CustomerDetailsPage />
      </PrivateRoute>
    ),
  },
  {
    path: ROUTES.settings,
    element: (
      <PrivateRoute>
        <GoalsProvider>
          <SettingsPage />
        </GoalsProvider>
      </PrivateRoute>
    ),
  },
  {
    path: ROUTES.forecast,
    element: (
      <PrivateRoute>
        <ForecastPage />
      </PrivateRoute>
    ),
  },
  {
    path: ROUTES.churn,
    element: (
      <PrivateRoute>
        <ChurnPage />
      </PrivateRoute>
    ),
  },
  {
    path: ROUTES.integrations,
    element: (
      <PrivateRoute>
        <Integrations />
      </PrivateRoute>
    ),
  },
  {
    path: "*",
    element: <NotFound />,
  },
]);
